const commonConfig = {
  // 1. OBSS API client id and secret (used for AWS SIT)
  svcHost: 'https://rbwm-api.hsbc.com.hk/wealth-wp-accreditation-shp-api-au-hkba-prod-proxy/v0',
  obssClientId: 'SINGAPORE',
  obssClientSecret: 'some client secret',
  breakpoint: 700,
  scores: {
    questionnaireId: 61,
    certIndicator: false,
    questionnaireType: 'ACCDT',
  },
  params: {
    action: 'A',
    response: {
      questionnaireId: 61,
      employeeNumber: '29000101',
      channelCode: 'OHI',
      // questionnaireStatus: 'ACCDTED',
      questionResponse: '',
    },
  },
  updateParams: {
    action: 'U',
    response: {
      questionnaireId: 61,
      responseId: 2521410,
      captureDateTime: '',
      expiryDateTime: '',
      totalScore: 0,
      questionResponse: '',
    },
  },
  specialParams: {
    accredited: {questionNumber: '93', answerNumber: 'B'},
    knowleageNum: {questionNumber: '96', answerNumber: 'B'},
    expQuestionObj: {questionNumber: '96', answerNumber: 'A'},
    knowleageSumbit: {questionNumber: '98', answerNumber: 'A', answerInputText: null},
    knowleageDraft: {questionNumber: '98', answerNumber: 'B', answerInputText: 'EQT'},
  },
  saas: {
    anonymousCommsTokenUrl:
      'https://rbwm-api.hsbc.com.hk/wealth-wp-accreditation-sa-shp-api-au-hkba-prod-proxy/v0/secsvc/anonymousCommsToken',
    saasIpUrl:
      'https://www.security.online-banking.hsbc.com.au/gsa?idv_cmd=idv.SaaSSecurityCommand&channel=WEB',
    postSaaSlogonRedirectUrl:
      'https://rbwm-api.hsbc.com.hk/wealth-wp-accreditation-sa-shp-api-au-hkba-prod-proxy/v0/SaasRedirection?redirectURL=',
    client_id: 'ee9040e831104176863fe594b0cc600b',
    client_secret: 'cfd8728597e24427BA44EA29EF93BCE0',
    Accept: '*/*',
  },
  gsp: {
    bankUrl:
      'https://www.services.online-banking.hsbc.com.au/gpib/group/gpib/cmn/layouts/default.html?uid=dashboard',
  },
  errorCauses: [
    {code: 'SYS9999', message: 'The System Error'},
    {code: 'QAS0005', message: 'Missing locale'},
    {code: 'QAS0006', message: 'Missing customer'},
    {code: 'QAS0007', message: 'Missing questionnaire response key'},
    {code: 'QAS0008', message: 'Missing maintenance action'},
    {code: 'QAS0009', message: 'Invalid maintenance action'},
    {code: 'QAS0010', message: 'Missing questionnaire response maintenance record'},
    {code: 'QAS0011', message: ''},
    {code: 'QAS0012', message: ''},
    {code: 'QAS0013', message: ''},
    {code: 'QAS0014', message: 'Missing answer number'},
    {code: 'QAS0125', message: ''},
    {code: 'QAS0127', message: ''},
    {code: 'CUS0404', message: 'Customer not exists'},
    {code: 'QAS0103', message: ''},
  ],
  knowleageUrl: [
    'equities',
    'fixedIncome',
    'exchangeTradedFunds',
    'structuredProducts',
    'options',
    'managedFunds',
    'futures',
    'warrants',
  ],
  tealium: {
    toUseTealium: true,
    prodEnvDesc: '',
    marketSuffix: '-rbwm-gsp',
  },
  accreditedInvestorHomepage: 'https://www.hsbc.com.au/investments/accredited-investor',
};
export default commonConfig;
